import React, {
  useContext,
  useState,
  useEffect
} from 'react';

import PropTypes from 'prop-types';

import NewAdditionalCard from 'src/Components/Common/AdditionalPlanCards/NewAdditionalCard';

import {
  SalesContext
} from 'src/Context/SalesContext';

import ServiceItems from 'src/UI/PlanDetails/components/ServiceItems/ServiceItems';

import WhiteDot from 'src/Components/Common/Svg/WhiteDot';

import './AdditionalServices.css';

const AdditionalServicesC = (props) => {

  const context = useContext(SalesContext);
  const [ isShowOptionsSuperWifi, setShowOptionsSuperWifi ] = useState(false);
  const [ isShowOptionsContractCover, setShowOptionsContractCover ] = useState(false);

  const {
    additionalServices,
    setAdditionalServices,
    setAdditionalVas,
    setSelectedAdditionalServices,
    selectedAdditionalServices,
    leadAdditionalServices,
    setLeadAdditionalServices
  } = context;

  function updateAdditionalServices(service, value) {

    if (service.vasCategory === 'superWifi' && superWifiPackages.length > 0) {
      if (!isShowOptionsSuperWifi && context.selectedContractTerm) {
        setShowOptionsSuperWifi(true);
      } else {
        setShowOptionsSuperWifi(false);
      }

      return;
    } else if (service.vasCategory === 'contractCover') {
      setShowOptionsContractCover(!isShowOptionsContractCover);

      return;
    } else {

      setSelectedAdditionalServices({ key: service.vasCategory, value: value });
      let currentServices = leadAdditionalServices;

      if (service.action === 'lead') {
        if (value) {
          currentServices.push(service.vasCategory);
        } else {
          currentServices.splice(currentServices.indexOf(service.vasCategory), 1);
        }

        setLeadAdditionalServices(currentServices);
      }
    }

    console.log('I am updateAdditionalServices and contract is:', context.selectedContractTerm);
  }

  const handleProductSelect = (service, product) => {
    // Handle product Select change
    let ObjIndex = additionalServices.findIndex(item => item.vasCategory === service.vasCategory);
    let productIndex = additionalServices[ObjIndex].products.findIndex(item => item.price === product.price);

    additionalServices[ObjIndex].products.map(item => item['selected'] = false);
    additionalServices[ObjIndex].products[productIndex]['selected'] = true;
    additionalServices[ObjIndex]['selectedProductSpeed'] = additionalServices[ObjIndex].products[productIndex].speed;
    additionalServices[ObjIndex]['selectedProductPrice'] = additionalServices[ObjIndex].products[productIndex].price;
    setAdditionalServices(additionalServices);

    props.updateTotalCost();
  };

  var superWifiPackages = [];
  var additionalServicesVAS = [];

  if (additionalServices && additionalServices.serviceCategories) {

    additionalServices.serviceCategories.map((service) => {
      if (service.vasCategory === 'superWifi' && service.offerId) {

        if (!parseInt(service.contractTerm)
          || (context.selectedContractTerm
            && service.contractTerm === context.selectedContractTerm)
        ) {
          superWifiPackages.push(service);
        }
      } else {
        additionalServicesVAS.push(service);
      }
    });
  }

  useEffect(() => {

    additionalServicesVAS.map((item) => {
      if (item.vasCategory === 'contractCover'
        && !context.selectedAdditionalServices.contractCover
        && !context.unselectedContractCover
      ) {
        let addVas = context.additionalVas;
        let addContractCover = true;

        if (!addVas) {
          addVas = [];
        }

        for (let index = 0; index < addVas.length; index++) {
          if (addVas[index].category === 'contractCover') {
            addContractCover = false;
          }
        }

        if (addContractCover) {
          addVas.push({
            'category': item.vasCategory,
            'offerId': item.offerId,
            'price': 'R' + item.priceDescription,
            'contractTerm': item.contractTerm,
            'acronym': item.acronym,
            'displayName': item.displayName,
            'priceDescription': item.priceDescription,
            'discount': item.discount ? item.discount : '',
            'imgUrl': item.imageUrl
          });
        }

        // setSelectedAdditionalServices({ key: item.vasCategory, value: true });
        // setAdditionalVas(addVas);
      }
    });
  }, [ additionalServices ]);

  if (superWifiPackages.length > 0) {
    additionalServicesVAS.unshift({
      'vasCategory': 'superWifi',
      'offerId': null,
      'name': null,
      'price': null,
      'contractTerm': null,
      'services': null,
      'displayName': 'Super WiFi',
      'imageUrl': 'https://contentqa.vodacom.co.za/content/fibre/sales/images/saleslead_superwifi_image.png',
      'promotion': null,
      'priceDescription': null,
      'description': 'Boost the WiFi coverage throughout your home.',
      'acronym': 'Super WiFi'
    });
  }

  additionalServicesVAS.map((item, index) => {
    if (item.vasCategory === 'contractCover' && index !== 0) {
      additionalServicesVAS.unshift(item);
      additionalServicesVAS.splice(index + 1, 1);
    }
  });

  let selectedSuperWifi;
  let selectedContractCover;

  let addVas = context.additionalVas;

  if (addVas) {
    for (let index = 0; index < addVas.length; index++) {
      if (addVas[index].category === 'superWifi') {
        selectedSuperWifi = addVas[index];
      }

      if (addVas[index].category === 'contractCover') {
        selectedContractCover = addVas[index];
      }
    }
  }

  return (

    <div className='additional-services-container'>

      { additionalServicesVAS.length > 0 && additionalServicesVAS.map((service, index) => {

        if (service?.vasCategory !== 'lte') {

          return (

            <React.Fragment key={index}>

              { service?.vasCategory === 'contractCover'

                ? <div className="new-plan-details-contract-cover-plus">

                  <div className="new-plan-details-review-plan-vertical-line-container">

                    <div className="new-plan-details-review-plan-dark-circle">
                      <WhiteDot />
                    </div>

                    <div className="new-plan-details-review-plan-vertical-line" />

                  </div>

                  <div className="new-plan-details-review-installation-address-wrapper">

                    <span className="new-plan-details-review-plan-wrapper-step">
                          Contract Cover Plus
                    </span>

                    <span className='new-plan-details-description'>
                          Affordable insurance that covers your Vodacom contract in the event of your death and provides R5,000 for funeral expenses.
                      <span onClick={ () => props.onLearnMore('learnMoreOnContractCover') } className='new-plan-details-learn-more-text'> Learn more</span>
                    </span>

                    <div className='LTE_PlansWrapper'>

                      <div className='cards_wrapper'>
                        <NewAdditionalCard
                          vasCategory={service?.vasCategory}
                          acronym={service?.acronym}
                          displayName={service?.displayName}
                          offerId={service?.offerId}
                          contractTerm={context.selectedContractTerm?.replace('Months', '').trim()}
                          price={'R' + service?.priceDescription}
                          priceDescription={service?.priceDescription}
                          index={1}
                          imgUrl={service?.imageUrl}
                          key={1}
                          additionalText={service.description}
                          isSelected={selectedContractCover && selectedContractCover.offerId === service?.offerId} />
                      </div>

                    </div>

                  </div>
                </div>
                : null
              }

              { service?.vasCategory === 'superWifi' && superWifiPackages.length > 0

                ? <div className="new-plan-details-super-wifi">

                  <div className="new-plan-details-review-plan-vertical-line-container">

                    <div className="new-plan-details-review-plan-dark-circle">
                      <WhiteDot />
                    </div>

                    <div className="new-plan-details-review-plan-vertical-line" />

                  </div>

                  <div className="new-plan-details-review-installation-address-wrapper">

                    <span className="new-plan-details-review-plan-wrapper-step">
                          Super Wifi
                    </span>

                    <span className='new-plan-details-description'>
                          Boost WiFi coverage throughout your home, with a free 14-day trial once your fibre is installed and activated.
                      <span onClick={ () => props.onLearnMore('learnMoreOnSuperWifi') } className='new-plan-details-learn-more-text'> Learn more</span>
                    </span>

                    <div className='cards_wrapper'>

                      { superWifiPackages.map((service, index) =>
                        <NewAdditionalCard
                          vasCategory={service?.vasCategory}
                          acronym={service?.acronym}
                          displayName={service?.displayName}
                          offerId={service?.offerId}
                          contractTerm={service?.contractTerm.replace('Months', '').trim()}
                          price={'R' + service?.priceDescription}
                          priceDescription={service?.priceDescription}
                          index={index}
                          discount={service?.discount}
                          imgUrl={service?.imageUrl}
                          key={index}
                          isSelected={selectedSuperWifi && selectedSuperWifi.offerId === service?.offerId} />
                      )}

                    </div>

                  </div>

                </div>

                : null
              }

              { service?.vasCategory === 'voiceLine'

                ? <div className="new-plan-details-voip">

                  <div className="new-plan-details-review-plan-vertical-line-container">

                    <div className="new-plan-details-review-plan-dark-circle">
                      <WhiteDot />
                    </div>

                    <div className="new-plan-details-review-plan-vertical-line" />

                  </div>

                  <div className="new-plan-details-review-installation-address-wrapper">

                    <span className="new-plan-details-review-plan-wrapper-step">
                          VoIP
                    </span>

                    <span className='new-plan-details-description'>
                          VoIP is a fixed line that uses the internet to make calls, allowing you to stay connected with loved ones and colleagues from anywhere in the world. A sales agent will be in touch to finalise pricing.
                    </span>

                    <div className='LTE_PlansWrapper'>

                      <div className='cards_wrapper'>
                        <NewAdditionalCard
                          vasCategory={service?.vasCategory}
                          acronym={service?.acronym}
                          displayName={service?.displayName}
                          offerId={service?.offerId}
                          price={'R' + service?.priceDescription}
                          priceDescription={service?.priceDescription}
                          index={1}
                          imgUrl={service?.imageUrl}
                          key={1}
                          additionalText={service.description}
                          isSelected={leadAdditionalServices.length > 0}
                          updateAdditionalServices={() => updateAdditionalServices(service, !selectedAdditionalServices[service.vasCategory])} />
                      </div>

                    </div>

                  </div>

                </div>
                : null
              }

              { service.showProduct

                ? <ServiceItems
                  service={service}
                  onProductSelect={(service, product) => handleProductSelect(service, product)} />

                : null
              }
            </React.Fragment>
          );
        }

      })}
    </div>
  );
};

AdditionalServicesC.propTypes = {
  onLearnMore: PropTypes.func,
  updateTotalCost: PropTypes.func
};

export const AdditionalServices = AdditionalServicesC;